export default __webpack_public_path__ + "static/media/bbminchem.e2afb944.png";